const headerData = {
  brandLink: "https://www.hiring-hub.com/",
  left: {
    link1: {
      label: "Employers",
      url: "https://www.hiring-hub.com/",
    },
    link2: {
      label: "Agencies",
      url: "https://www.hiring-hub.com/recruitment-agency-register/",
    },
  },
  right: {
    link1: {
      label: "How it works",
      url: "https://www.hiring-hub.com/how-hh-works/",
    },
    link2: {
      label: "Reviews",
      url: "https://www.hiring-hub.com/testimonials-and-reviews/",
    },
    link3: {
      label: "FAQs",
      url: "https://www.hiring-hub.com/faqs/",
    },
    link4: {
      label: "Login",
      url: "https://app.hiring-hub.com/",
    },
    link5: {
      label: "Post a job ➤",
      url: "https://www.hiring-hub.com/Post-a-job-V2/",
    },
  },
};

export { headerData as default };
